// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { lessonFields } from '~/gql/records/lessonFragment.graphql'
import { sectionRichTextFields } from '~/gql/sections/richtTextSection.graphql'

export const lessonPageQuery = gql`
  query LessonPage($locale: SiteLocale, $slug: String) {
    lesson(locale: $locale, filter: { slug: { eq: $slug } }) {
      ...lessonFields
      firstPublishedAt: _firstPublishedAt
      content {
        ...sectionRichTextFields
      }
      seo: _seoMetaTags {
        tag
        attributes
        content
      }
      slugLocales: _allSlugLocales {
        locale
        slug: value
      }
    }
  }
  ${lessonFields}
  ${sectionRichTextFields}
`

export const nextLessonQuery = gql`
  query LessonPage($locale: SiteLocale, $lessonNumber: IntType) {
    lesson(locale: $locale, filter: { lessonNumber: { eq: $lessonNumber } }) {
      ...lessonFields
    }
  }
  ${lessonFields}
`
